import ReviewLinks from './ReviewLinks';
import ReviewWholescale from './ReviewWholescale';
import ReviewYotpo from './ReviewYotpo';
import TiktokPublish from './TiktokPublish';
import UrlSubmit from './UrlSubmit';

const index = {
  ReviewLinks,
  ReviewWholescale,
  ReviewYotpo,
  TiktokPublish,
  UrlSubmit,
};

export default index;